export * from './baFileUploader.component';



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/components/baFileUploader/index.ts